import { useState , createContext , useContext, useEffect } from 'react';
import { getOrgUserDetails } from '../services/CommonService';

const OrgContext = createContext('');

const useOrgContext = () => useContext(OrgContext);

const client = window.document.location.hostname.split(".")[0];
// const client = 'dash-dev-ati';
// "dash-staging-ati", "dash-dev-st", "dash-staging-st"

const OrgContextProvider = ({ children }) => {
    const [ orgDetails , setOrgDetials ] = useState('');
    const [ isOrgAdmin , setIsOrgAdmin ] = useState(null);
    const [ isLogedOut , setIsLogedOut ] = useState(false);

    useEffect(() => {
        (() => {
            if( isOrgAdmin === null && isLogedOut === false ){
                getOrgUserDetails().then( res => {
                    setIsOrgAdmin(res.permission);
                    return res.permission;
                });
            }else{
                return isOrgAdmin;
            }
        })()
    } ,[]);

    return <OrgContext.Provider value={{ orgDetails , setOrgDetials, isOrgAdmin , setIsOrgAdmin, setIsLogedOut }}>{children}</OrgContext.Provider>
}



export {
    useOrgContext,
    OrgContextProvider,
    client,
}